import { useMemo } from 'react';

import {
  SizeSmallVariantWhite,
  SizeSmallVariantPrimary,
  SizeSmallVariantWhiteIcon,
  SizeSmallVariantPrimaryIcon,
} from '@/assets';

import type { LogoProps, LogosObj } from './Logo.types';

import logoVariants from './Logo.variants';

const logos: LogosObj = {
  'dark-default': SizeSmallVariantPrimary,
  'dark-icon': SizeSmallVariantPrimaryIcon,
  'light-default': SizeSmallVariantWhite,
  'light-icon': SizeSmallVariantWhiteIcon,
};

export function Logo({
  size = 'md',
  variant = 'dark',
  isIcon = false,
  className,
  ...props
}: LogoProps) {
  const LogoComponent = useMemo(() => {
    return logos[`${variant}-${isIcon ? 'icon' : 'default'}`];
  }, [variant, isIcon]);

  return (
    <LogoComponent
      aria-label="Logo"
      {...props}
      className={logoVariants({
        className,
        size,
        style: isIcon ? 'isIcon' : 'default',
      })}
    />
  );
}
